/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentTemplateComponents } from 'app/entities/treatment-template-component/treatment-template-component.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './regimen.reducer';

export const RegimenUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentTemplateComponents = useAppSelector(state => state.treatmentTemplateComponent.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const regimenEntity = useAppSelector(state => state.regimen.entity);
  const loading = useAppSelector(state => state.regimen.loading);
  const updating = useAppSelector(state => state.regimen.updating);
  const updateSuccess = useAppSelector(state => state.regimen.updateSuccess);

  const handleClose = () => {
    navigate(`/regimen${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentTemplateComponents({}));
    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.noOfCycles !== undefined && typeof values.noOfCycles !== 'number') {
      values.noOfCycles = Number(values.noOfCycles);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...regimenEntity,
      ...values,
      templateComponent: treatmentTemplateComponents.find(it => it.id.toString() === values.templateComponent?.toString()),
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...regimenEntity,
          templateComponent: regimenEntity?.templateComponent?.id,
          doctor: regimenEntity?.doctor?.id,
          hospital: regimenEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.regimen.home.createOrEditLabel" data-cy="RegimenCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.regimen.home.createOrEditLabel">Create or edit a Regimen</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="regimen-id"
                  label={translate('tinyMedicRestApp.regimen.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.regimen.name')} id="regimen-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.description')}
                id="regimen-description"
                name="description"
                data-cy="description"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.noOfCycles')}
                id="regimen-noOfCycles"
                name="noOfCycles"
                data-cy="noOfCycles"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.active')}
                id="regimen-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.cursor')}
                id="regimen-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.lastUpdated')}
                id="regimen-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.microSec')}
                id="regimen-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.timestampEntry')}
                id="regimen-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.global')}
                id="regimen-global"
                name="global"
                data-cy="global"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="globalLabel">
                <Translate contentKey="tinyMedicRestApp.regimen.help.global" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.regimen.sharedInternally')}
                id="regimen-sharedInternally"
                name="sharedInternally"
                data-cy="sharedInternally"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="sharedInternallyLabel">
                <Translate contentKey="tinyMedicRestApp.regimen.help.sharedInternally" />
              </UncontrolledTooltip>
              <ValidatedField
                id="regimen-templateComponent"
                name="templateComponent"
                data-cy="templateComponent"
                label={translate('tinyMedicRestApp.regimen.templateComponent')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentTemplateComponents
                  ? treatmentTemplateComponents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.regimen.doctor')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="regimen-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.regimen.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/regimen" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RegimenUpdate;
